export default __webpack_public_path__ + "static/media/Sixft.53cb14c7.png";